import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import Storage from '../utils/Storage'
import {initWebSocketPlugin} from './plugins/sdkEvents'
import BusEvents from './plugins/BusEvents'
import SdkStore from './modules/sdkStore'

Vue.use(Vuex)

window.$historyStorage = new Storage()
window.Bus = new Vue();

const debug = configs.debug

var _clinetSDK = new IMClientSDK({
  intervalTime: configs.intervalTime,
  isPoll: configs.isPoll,
  appkey: configs.AppKey,
  debug: configs.debug,
  ip: configs.websocketUrl,
  apiUrl: configs.apiUrl,
  anonyUrl: configs.anonyUrl,
  tokenUrl: configs.tokenUrl,
  imageServiceUrl: configs.imageServiceUrl,
  websocketOnly: configs.websocketOnly,
});

var sdkPlugin = initWebSocketPlugin(_clinetSDK);

export default new Vuex.Store({
  modules: {
    SdkStore
  },
  strict: debug,
  plugins: debug ? [createLogger(), BusEvents, sdkPlugin] : [BusEvents, sdkPlugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js